import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["className"];
import Component from '../../common/Component';
import classList from '../../common/utils/classList';
export default class FormSection extends Component {
  view(vnode) {
    const _this$attrs = this.attrs,
      {
        className
      } = _this$attrs,
      attrs = _objectWithoutProperties(_this$attrs, _excluded);
    return m("div", Object.assign({
      className: classList('FormSection', className)
    }, attrs), m("label", null, this.attrs.label), m("div", {
      className: "FormSection-body"
    }, vnode.children));
  }
}
flarum.reg.add('core', 'admin/components/FormSection', FormSection);